// extracted by mini-css-extract-plugin
module.exports = {"root":"meetings_root__Bo6ay"};